export default {
  // Nawigacja
  'nav.spreadsheet': 'Arkusz',
  'nav.categories': 'Kategorie',
  'nav.guide': 'Przewodnik',
  'nav.faq': 'FAQ',
  'nav.home': 'Strona główna',
  'nav.shopping': 'Przewodnik zakupowy',
  'nav.cta': 'Kup teraz',

  // Hero
  'hero.badge': 'Niezależny zasób · Przewodniki wielojęzyczne · Bezpieczeństwo',
  'hero.h1': 'Arkusz USFans — znajdź, odkrywaj i porządkuj informacje o USFans',
  'hero.sub': 'Poznaj zasoby arkusza USFans, przewodniki po twórcach, recenzje, informacje o wysyłce, kupony, przewodniki magazynowe i zasoby dotyczące bezpieczeństwa — wszystko w jednej szybkiej platformie.',
  'hero.ctaPrimary': 'Przeglądaj arkusz USFans',
  'hero.ctaSecondary': 'Przeczytaj przewodnik USFans',
  'hero.trust': 'Niezależny zasób • Aktualne treści • Przewodniki wielojęzyczne • Bezpieczeństwo',
  'hero.scroll': 'Przewiń, aby odkrywać',

  // Lista rozwijana
  'dropdown.label': 'Przeglądaj kategorie',
  'dropdown.placeholder': 'Wybierz kategorię…',

  // Kategorie
  'categories.title': 'Zakupy według kategorii',
  'categories.sub': 'Przeglądaj popularne kategorie USFans i odkrywaj style — wszystko w jednym miejscu. Każdy link otwiera oficjalny sklep w nowej karcie.',
  'categories.hint': 'Każda kategoria prowadzi do głównego sklepu USFans.',
  'categories.view': 'Otwórz kategorię',

  // Karty funkcji
  'features.title': 'Wszystko, czego potrzebujesz, w jednym miejscu',
  'features.sub': 'Kompletne centrum zasobów USFans oparte na jasnych, przydatnych informacjach.',
  'features.1.title': 'Arkusz USFans',
  'features.1.desc': 'Poznaj uporządkowane zasoby i przewodniki arkusza USFans.',
  'features.2.title': 'Recenzja USFans',
  'features.2.desc': 'Zrozum funkcje, użyteczność, wysyłkę i ważne kwestie.',
  'features.3.title': 'Koszt wysyłki USFans',
  'features.3.desc': 'Dowiedz się, jak działają koszty wysyłki i co wpływa na cenę końcową.',
  'features.4.title': 'Kupon USFans',
  'features.4.desc': 'Znajdź informacje o kuponach, promocjach i zniżkach.',
  'features.5.title': 'Magazyn USFans',
  'features.5.desc': 'Dowiedz się, jak działają magazynowanie, kontrola i wysyłka.',
  'features.6.title': 'Czy USFans jest legalny?',
  'features.6.desc': 'Poznaj legalność, bezpieczeństwo, prywatność i typowe ryzyka.',

  // O nas
  'about.title': 'Szukasz lepszego sposobu na poznanie informacji o USFans?',
  'about.p1': 'Nasze centrum arkusza USFans łączy przydatne przewodniki, zasoby twórców, recenzje, informacje o wysyłce, wyjaśnienia magazynowe, zniżki, porównania i wskazówki bezpieczeństwa w jednym miejscu.',
  'about.p2': 'Niezależnie od tego, czy badasz USFans po raz pierwszy, czy szukasz konkretnych informacji, zacznij od centrum arkusza USFans.',

  // Przewodnik CTA
  'guide.title': 'Przeczytaj nasz przewodnik po arkuszu USFans',
  'guide.sub': 'Kompletny, oryginalny przewodnik o tym, czym jest arkusz USFans, jak działa, jak wyszukiwać twórców i jak zachować bezpieczeństwo.',
  'guide.cta': 'Przeczytaj pełny przewodnik',
  'guide.meta': 'Zaktualizowano · Oryginalna treść · Bezpieczeństwo',

  // Przewodniki
  'guides.title': 'Wszystkie przewodniki USFans',
  'guides.sub': 'Kompletna biblioteka pogłębionych przewodników o arkuszu, twórcach, recenzjach, wysyłce, kuponach, magazynie i bezpieczeństwie.',

  // FAQ
  'faq.title': 'Często zadawane pytania',
  'faq.sub': 'Szybkie odpowiedzi na temat zasobu Arkusz USFans.',
  'faq.1.q': 'Czym jest arkusz USFans?',
  'faq.1.a': 'To uporządkowany zasób, który zbiera informacje o USFans — listy twórców, kategorie, przewodniki i linki — w jednym łatwym miejscu.',
  'faq.2.q': 'Czy ta strona jest powiązana z USFans?',
  'faq.2.a': 'Nie. USFansLink.rest to niezależna strona informacyjna, która nie musi być powiązana z USFans ani przez niego wspierana.',
  'faq.3.q': 'Jak przeglądać kategorie USFans?',
  'faq.3.a': 'Użyj listy rozwijanej kategorii lub przycisków kategorii poniżej. Każdy otwiera pasującą kategorię w głównym sklepie USFans.',
  'faq.4.q': 'Czy przewodniki są darmowe?',
  'faq.4.a': 'Tak, wszystkie przewodniki i artykuły na tej stronie są darmowe i mają charakter informacyjny.',
  'faq.5.q': 'Czy weryfikujecie informacje?',
  'faq.5.a': 'Staramy się, aby treści były przydatne i dokładne, ale informacje zewnętrzne mogą się zmieniać. Zawsze weryfikuj szczegóły samodzielnie.',

  // Główne CTA
  'cta.title': 'Gotowy, aby poznać pełny sklep USFans?',
  'cta.sub': 'Przeglądaj pełną kolekcję, odkrywaj nowe kategorie i rób zakupy bezpośrednio na głównej stronie USFans.',
  'cta.primary': 'Arkusz USFans',
  'cta.secondary': 'Kup teraz',

  // Stopka
  'footer.tagline': 'Niezależny, wielojęzyczny zasób do poznawania informacji o USFans.',
  'footer.disclaimer': 'USFansLink.rest to niezależna strona informacyjna, która nie musi być powiązana z USFans ani przez niego wspierana. Informacje zewnętrzne mogą się zmieniać; weryfikuj szczegóły samodzielnie.',
  'footer.links': 'Szybkie linki',
  'footer.copyright': '© 2026 USFansLink.rest. Wszelkie prawa zastrzeżone.',

  // Artykuł
  'article.breadcrumb': 'Strona główna',
  'article.category': 'Przewodnik',
  'article.shortTitle': 'Przewodnik po arkuszu USFans',
  'article.readTime': '8 min czytania',
  'article.updated': 'Zaktualizowano',
  'article.toc': 'Spis treści',
  'article.related': 'Powiązane przewodniki',

  'article.h1': 'Arkusz USFans: kompletny przewodnik po twórcach, wyszukiwaniu i zasobach',
  'article.lead': 'Dowiedz się, czym jest arkusz USFans, jak działa, jak wyszukiwać twórców, porządkować informacje i zachować bezpieczeństwo — w jednym kompletnym przewodniku.',

  'article.s1.title': 'Czym jest arkusz USFans?',
  'article.s1.p1': 'Arkusz USFans to uporządkowany, współdzielony zasób, który zbiera informacje o USFans w czytelnym formacie. Zazwyczaj łączy listy twórców, kategorie, profile, statusy, daty aktualizacji i przydatne linki w jednym widoku przypominającym tabelę.',
  'article.s1.p2': 'Dla wielu osób arkusz jest centralnym punktem wyjścia. Zamiast przeszukiwać wiele osobnych stron, użytkownicy mogą przejrzeć jeden uporządkowany układ, aby szybko znaleźć to, czego szukają. Jest to szczególnie przydatne do odkrywania nowych twórców i kategorii.',

  'article.s2.title': 'Jak działa arkusz',
  'article.s2.p1': 'Większość arkuszy USFans ma prostą strukturę opartą na kolumnach. Typowy układ zawiera kolumny: nazwa twórcy, kategoria, link do profilu, aktualny status i data ostatniej aktualizacji. Taka struktura ułatwia sortowanie, filtrowanie i porównywanie informacji.',
  'article.s2.p2': 'Niektóre arkusze są aktualizowane ręcznie i według harmonogramu, inne częściej. Ponieważ dane mogą się zmieniać, zawsze warto sprawdzić źródło i zweryfikować ważne szczegóły.',

  'article.s3.title': 'Jak wyszukiwać twórców',
  'article.s3.p1': 'Wyszukiwanie w arkuszu USFans zwykle zaczyna się od kategorii lub filtrów. Jeśli szukasz konkretnego twórcy, użyj funkcji wyszukiwania lub filtrowania, aby zawęzić wyniki po nazwie. Jeśli eksplorujesz, przeglądaj najpierw według kategorii.',
  'article.s3.p2': 'Dobrym podejściem jest zaczynanie szeroko, a potem zawężanie. Zacznij od interesującej kategorii, a następnie sprawdź status i informacje o aktualizacji, aby skupić się na aktywnych wpisach.',

  'article.s4.title': 'Popularne kategorie',
  'article.s4.p1': 'Zasoby USFans są często grupowane w kategorie, aby ułatwić przeglądanie. Zwykle obejmują odzież, obuwie, akcesoria, torby, paski, zapachy i inne przedmioty. Grupowanie pomaga porównywać podobne opcje obok siebie.',
  'article.s4.p2': 'Na tej stronie lista rozwijana i przyciski kategorii prowadzą do odpowiedniej sekcji głównego sklepu, więc możesz przejść od badań do przeglądania prawdziwych produktów.',

  'article.s5.title': 'Arkusz a katalog a wyszukiwanie ręczne',
  'article.s5.p1': 'Warto zrozumieć, jak arkusz wypada w porównaniu z innymi sposobami znajdowania informacji. Poniższa tabela podsumowuje główne różnice.',
  'article.table.c1': 'Aspekt',
  'article.table.c2': 'Arkusz',
  'article.table.c3': 'Katalog',
  'article.table.c4': 'Wyszukiwanie ręczne',
  'article.table.r1c1': 'Format',
  'article.table.r1c2': 'Uporządkowane wiersze i kolumny',
  'article.table.r1c3': 'Strony z listami kategorii',
  'article.table.r1c4': 'Jedno wyszukiwanie na raz',
  'article.table.r2c1': 'Najlepsze do',
  'article.table.r2c2': 'Skanowania i porównywania',
  'article.table.r2c3': 'Przeglądania według tematu',
  'article.table.r2c4': 'Znajdowania konkretnego elementu',
  'article.table.r3c1': 'Aktualność',
  'article.table.r3c2': 'Zależy od aktualizacji',
  'article.table.r3c3': 'Zależy od utrzymania',
  'article.table.r3c4': 'Zawsze na bieżąco',
  'article.table.r4c1': 'Krzywa uczenia',
  'article.table.r4c2': 'Niska',
  'article.table.r4c3': 'Bardzo niska',
  'article.table.r4c4': 'Brak',

  'article.s6.title': 'Weryfikacja danych i bezpieczeństwo',
  'article.s6.p1': 'Ponieważ arkusze i katalogi USFans są często tworzone przez społeczność, informacje mogą nie być zawsze kompletne lub aktualne. Zawsze weryfikuj ważne szczegóły, takie jak linki, ceny i dostępność, bezpośrednio w oficjalnym sklepie.',
  'article.s6.p2': 'Zachowaj ostrożność wobec linków proszących o dane osobowe lub płatności poza oficjalną stroną. Korzystaj ze znanych, zaufanych linków i nigdy nie udostępniaj haseł ani danych konta.',

  'article.s7.title': 'Prywatność',
  'article.s7.p1': 'Podczas przeglądania zasobów zewnętrznych uważaj, jakie informacje udostępniasz. Unikaj wpisywania wrażliwych danych na nieznanych stronach i korzystaj z oficjalnej strony przy koncie i zakupach.',
  'article.s7.p2': 'Ten niezależny zasób nie wymaga danych osobowych do przeglądania. Jeśli strona prosi o niepotrzebne dane, lepiej ją zamknąć i wrócić do oficjalnego źródła.',

  'article.conclusion.title': 'Podsumowanie',
  'article.conclusion.p1': 'Arkusz USFans to wygodny sposób na poznawanie twórców, kategorii i zasobów w jednym miejscu. Działa najlepiej w połączeniu z samodzielną weryfikacją i zdrowym rozsądkiem.',
  'article.conclusion.p2': 'Gotowy, aby przeglądać prawdziwe produkty? Skorzystaj z listy kategorii na stronie głównej lub przejdź bezpośrednio do pełnego sklepu USFans.',

  'article.cta': 'Poznaj pełny zasób',
  'article.backHome': 'Wróć na stronę główną',

  // Nazwy kategorii
  'cat.shoes': 'Buty',
  'cat.hoodies': 'Bluzy / Swetry',
  'cat.tshirts': 'Koszulki',
  'cat.jackets': 'Kurtki',
  'cat.pants': 'Spodnie / Szorty',
  'cat.headwear': 'Nakrycia głowy',
  'cat.sets': 'Zestawy',
  'cat.underwear': 'Bielizna',
  'cat.jersey': 'Koszulka sportowa',
  'cat.accessories': 'Akcesoria',
  'cat.bags': 'Torby',
  'cat.belts': 'Paski',
  'cat.perfumes': 'Perfumy',
  'cat.other': 'Inne rzeczy',
};